import React, {FC} from "react";

interface BGaugeData {
    percentage?: any,
    color?: any,
}

const BGauge: FC<BGaugeData> = (props) => {
  // @ts-ignore
  return <div className="bs-gauge" style={{width: '40px', '--rotation':`${1.8 * (props?.percentage ?? 0)}deg`, '--color':`${props?.color ?? '#5cb85c'}`, '--background':'#e9ecef'}}>
    <div className="h_percentage"></div>
    <div className="h_mask"></div>
  </div>;
};

export default BGauge;
